const mutations = {
  setPermissions(state, permissions) {
    state.permissions = permissions;
  },
  addPermission(state, { key, value }) {
    state.permissions[key] = value;
  },
};

export default mutations;
